import { VideoCreatorErrorCode } from '../../types/store';

export function getBabelKeyFromErrorCode(code: VideoCreatorErrorCode): string | null {
  switch (code) {
    case VideoCreatorErrorCode.UPLOAD_ERROR:
      return 'studio.videoCreator.errorMessage.uploadError';
    case VideoCreatorErrorCode.UPLOADS_TEMPORARILY_DISABLED:
      return 'upload.error.temporarilyDisabled';
    case VideoCreatorErrorCode.ILLEGAL_PROMPT:
      return 'studio.videoCreator.errorMessage.illegalPrompt';
    case VideoCreatorErrorCode.OUT_OF_SPACE:
      return 'studio.videoCreator.errorMessage.outOfSpace';
    case VideoCreatorErrorCode.OUT_OF_FILE_QUOTA:
      return 'studio.videoCreator.errorMessage.outOfFileQuota';
    case VideoCreatorErrorCode.TOS_VIOLATION:
      return 'studio.videoCreator.errorMessage.tosViolation';
    case VideoCreatorErrorCode.TOO_FAST:
      return 'studio.videoCreator.errorMessage.tooFast';
    case VideoCreatorErrorCode.VALIDATION_ERROR:
      return 'studio.videoCreator.errorMessage.validationError';
    case VideoCreatorErrorCode.OTHER:
      return 'studio.videoCreator.errorMessage.other';

    case VideoCreatorErrorCode.INSUFFICIENT_POINTS_BALANCE: // This error triggers the points modal, so this won't ever get here
    case VideoCreatorErrorCode.NO_ERROR:
    default:
      return null;
  }
}
